import { render } from "./TwoColumnOptionsEditor.vue?vue&type=template&id=1d1cfc5b&ts=true"
import script from "./TwoColumnOptionsEditor.vue?vue&type=script&lang=ts"
export * from "./TwoColumnOptionsEditor.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__